import { createApp } from 'vue';
import axios from 'axios';
import App from './App.vue';
import router from './router';
import store from './store';
import { lanAwareUrl } from './utils/serverUrl';
import './index.css';

axios.interceptors.request.use((config) => {
  if (config.url) {
    config.url = lanAwareUrl(config.url);
  }
  if (config.baseURL) {
    config.baseURL = lanAwareUrl(config.baseURL);
  }
  return config;
});

store.commit('onMessage');
createApp(App).use(store).use(router).mount('#app');
